<template>
	<b-card header-tag="header">
		<template #header style="position: relative">
			<b-row>
				<b-col align="left">
					<b-badge @click="$router.push(`/point-of-sale/before-pos`)" style="padding: 10px; font-size: 15px; cursor: pointer" variant="primary" class="fa fa-arrow-left focus-out"><b class="ml-2">В меню</b></b-badge>
				</b-col>
				<b-col align="center">
					<b-button-group>
						<b-button @click="activeTab='income'" :variant="activeTab==='income' ? 'dark' : 'outline-dark'" style="font-size: 15px; border-radius: 10px 0 0 10px; cursor: pointer; font-weight: bold">Приход</b-button>
						<b-button @click="activeTab='accept'" :variant="activeTab==='accept' ? 'dark' : 'outline-dark'" style="font-size: 15px; border-radius: 0; cursor: pointer; font-weight: bold">Принятые</b-button>
						<b-button @click="activeTab='sent'" :variant="activeTab==='sent' ? 'dark' : 'outline-dark'" style="font-size: 15px; border-radius: 0 10px 10px 0; cursor: pointer; font-weight: bold">Отправленые</b-button>
					</b-button-group>
				</b-col>
				<b-col/>
			</b-row>
		</template>
		<b-overlay :show="loading" rounded="sm">
			<table style="width: 100%" class="b-table table-hover table-striped table-bordered">
				<thead>
					<tr>
						<th class="text-center">№</th>
						<th class="text-center">Дата</th>
						<th class="text-center">Документ №</th>
						<th class="text-center">Отправитель</th>
						<th class="text-center">Получатель</th>
						<th class="text-center">Основания</th>
						<th class="text-center">Действие</th>
					</tr>
				</thead>
				<tbody v-if="list || list.length > 0">
					<tr v-for="(doc, index) in list" :key="`docs-${index}`">
						<td class="text-center"><strong>{{ paginate(index, search.page, search.limit) }}</strong></td>
						<td class="text-center">{{ doc.regDate }}</td>
						<td class="text-center">{{ doc.regNumber }}</td>
						<td class="text-center">{{ doc.fromDepartmentName }}</td>
						<td class="text-center">{{ doc.toDepartmentName }}</td>
						<td class="text-center">{{ doc.reason }}</td>
						<td class="text-center">
							<b-button v-if="activeTab==='income'" @click="$router.push(`/warehouse-management/income/pending/${doc.id}`)" variant="dark"><i class="fa fa-eye"/></b-button>
							<b-button v-else @click="$router.push(`/warehouse-management/transfers/view/${doc.id}`)" variant="dark"><i class="fa fa-eye"/></b-button>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr>
						<td colspan="8" class="text-center">Пока нет информации</td>
					</tr>
				</tbody>
			</table>
			<nav class="text-center mt-2">
				<b-pagination-new background :total="total" layout="prev, pager, next" :page-size="search.limit" :current-page.sync="search.page"/>
			</nav>
		</b-overlay>
	</b-card>
</template>

<script>
import { Pagination } from 'element-ui'
import WhDocument from "../../../services/wh-document.service";
import { BOverlay } from 'bootstrapVue2';

export default {
	name: "transferIncome",
	components: {"b-pagination-new":Pagination,BOverlay},
	data() {
		return {
			search: {
				page: 1,
				limit: 20
			},
			list: [],
			total: 0,
			activeTab: 'income',
			loading: false
		}
	},
	watch: {
		'search.page': {
			handler(p) {
				this.getList();
			}
		},
		'activeTab': {
			handler(a) {
				this.getList('change');
			}
		}
	},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		getList(change) {
			this.loading = true
			if (change==='change') {
				this.search.page = 1
				this.list=[]
				this.total=0
			}
			if (this.activeTab==='income') {
				WhDocument.getTransferIncomeList(this.search, localStorage.getItem('dep_id')).then(res => {
					this.list = res.data.items
					this.total = res.data.total
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else if (this.activeTab === 'sent') {
				WhDocument.getTransferSentList(this.search, localStorage.getItem('dep_id')).then(res => {
					this.list = res.data.items
					this.total = res.data.total
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				WhDocument.getTransferList(this.search, localStorage.getItem('dep_id')).then(res => {
					this.list = res.data.items
					this.total = res.data.total
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
		}
	},
	created() {
		this.getList();
	}
}
</script>

<style scoped>

</style>
